import React from 'react';
import { useMenuItemWithContext } from './menuContext';

const NavigationItemMenuStructure = ({ triggerContent, children, onclick }) => {
  const [isOpen, setOpen] = useMenuItemWithContext();
  const handleClick = () => {
    onclick();
    setOpen(!isOpen);
  };
  const baseElementClassName = 'navigation__menu-item';
  const elementClassName = baseElementClassName + (isOpen ? ' ' + baseElementClassName + '--open' : '');
  return (
    <li
      className={elementClassName}
    >
      <button className="navigation__menu-item__trigger" onClick={handleClick}>
        {triggerContent}
      </button>

      <div className={`navigation__menu-item__tray ${isOpen ? 'navigation__menu-item__tray--open' : 'navigation__menu-item__tray--close'}`}>
        {children}
      </div>
    </li>
  );
};

export default NavigationItemMenuStructure;
